import React from "react";
import {
  Box,
  Container,
  Typography,
  Stack,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import CookieIcon from "@mui/icons-material/Cookie";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import SettingsIcon from "@mui/icons-material/Settings";

export default function CookiePolicy() {
  return (
    <Box component="main" sx={{ py: 8, background: "#fff" }}>
      <Container maxWidth="md">
        <Stack spacing={3}>
          <Typography variant="h4" fontWeight={800}>
            Cookie Policy — FentrixBank
          </Typography>

          <Typography>
            This Cookie Policy explains how FentrixBank (“we”, “us”) uses cookies and
            similar technologies on our website and apps to provide and improve our
            services.
          </Typography>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            What are cookies?
          </Typography>

          <Typography>
            Cookies are small text files stored on your device that help recognize your
            preferences and improve performance.
          </Typography>

          <List>
            <ListItem>
              <ListItemIcon>
                <CookieIcon />
              </ListItemIcon>
              <ListItemText primary="Essential Cookies" secondary="Required for logins, sessions, and core functionality." />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <AnalyticsIcon />
              </ListItemIcon>
              <ListItemText primary="Analytics Cookies" secondary="Help us understand usage patterns and improve performance." />
            </ListItem>

            <ListItem>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText primary="Preference Cookies" secondary="Store your language and display preferences." />
            </ListItem>
          </List>

          <Divider />

          <Typography variant="h6" fontWeight={700}>
            Managing cookies
          </Typography>

          <Typography>
            Most browsers allow you to block or delete cookies. Disabling cookies may
            affect functionality. For analytics opt-out or cookie settings, visit your
            browser's privacy settings or the account preferences page.
          </Typography>

          <Typography variant="body2" color="text.secondary">
            For questions about our cookie usage, contact privacy@fentrixbank.com.
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}